import React from 'react';

import { ADGMPanel } from 'aurora-components';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ADGMPanelInputsGeneratorBody from './ADGMPanelInputsGeneratorBody';
import styles from './styles';

const ADGMPanelInputsGenerator = ({ sections, classes, isEditable, children, bodyStyle, dividerStyle, ...props }) => {
  return (
    <ADGMPanel {...props}>
      <ADGMPanelInputsGeneratorBody {...{ sections, isEditable, bodyStyle, dividerStyle }} />
      {children}
    </ADGMPanel>
  );
};

ADGMPanelInputsGenerator.propTypes = {
  classes: PropTypes.object.isRequired,
  isEditable: PropTypes.object.isRequired,
  children: PropTypes.node,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      error: PropTypes.string,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          placeholder: PropTypes.string.isRequired,
          type: PropTypes.oneOf(['dropdown, text']).isRequired,
          required: PropTypes.bool.isRequired,
          label: PropTypes.string.isRequired,
          options: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.string.isRequired,
              label: PropTypes.string.isRequired,
            }),
          ),
        }),
      ),
    }),
  ).isRequired,
  bodyStyle: PropTypes.object,
  dividerStyle: PropTypes.object,
};
ADGMPanelInputsGenerator.defaultProps = {
  children: null,
  bodyStyle: {},
  dividerStyle: {},
};

export default withStyles(styles)(ADGMPanelInputsGenerator);
